import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { useRelFollowContact, useRelGetFollowing, useRelUnfollowContact } from '@vatom/sdk/react'
import { translate } from '@vatom/utils'
import { colors } from '@vatom/wombo'
import { Box, Pressable } from 'native-base'

import { useCommunitiesTheme } from '../../Communities/themes'
import FollowIcon from '../assets/follow.svg'
import FollowingIcon from '../assets/following.svg'
import MessageIcon from '../assets/message.svg'

interface IProfileActionsProps {
  userId: string
}

const ProfileActions = ({ userId }: IProfileActionsProps) => {
  const communitiesTheme = useCommunitiesTheme()

  const following = useRelGetFollowing({
    select: contacts => {
      return contacts.find(c => c.value === userId)
    }
  })
  const followMutation = useRelFollowContact()
  const unfollowMutation = useRelUnfollowContact()

  const followOrUnfollow = () => {
    if (following.data) {
      unfollowMutation.mutate(following.data)
    } else {
      followMutation.mutate({
        type: 'user',
        value: userId
      })
    }
  }

  return (
    <Box
      flexDirection={'row'}
      flex={1}
      alignItems={'center'}
      justifyContent={'space-between'}
      marginX={4}
      borderRadius={4}
      marginY="20px"
      _web={{
        minWidth: 360
      }}
    >
      {/* <View
        style={[
          styles.memberAction,
          { backgroundColor: 'transparent' },
          { borderColor: communitiesTheme?.memberActionButtons?.border }
        ]}
      >
        <MessageIcon
          style={{ width: 16, height: 16, marginRight: 4 }}
          fill={communitiesTheme?.memberActionButtons?.text ?? '#3F4A55'}
        />
        <Text style={[styles.text, { color: communitiesTheme.memberActionButtons.text }]}>
          Message
        </Text>
      </View> */}

      <Pressable
        accessibilityRole="button"
        style={[
          styles.memberAction,
          {
            backgroundColor: following.data
              ? 'transparent'
              : communitiesTheme.memberActionButtons.backgroundColor
          },
          { borderColor: communitiesTheme?.memberActionButtons?.border },
          { width: '100%' }
        ]}
        onPress={followOrUnfollow}
      >
        {following.data ? (
          <>
            <FollowingIcon style={{ width: 16, height: 16, marginRight: 4 }} fill={'#3F4A55'} />
            <Text style={[styles.text, { color: '#3F4A55' }]}>{translate('common.following')}</Text>
          </>
        ) : (
          <>
            <FollowIcon
              style={{ width: 16, height: 16, marginRight: 4 }}
              fill={communitiesTheme?.memberActionButtons?.text ?? '#3F4A55'}
            />
            <Text style={[styles.text, { color: communitiesTheme.memberActionButtons.text }]}>
              {translate('common.follow')}
            </Text>
          </>
        )}
      </Pressable>
    </Box>
  )
}

export default ProfileActions

const styles = StyleSheet.create({
  memberAction: {
    backgroundColor: 'white',
    paddingVertical: 11,
    paddingHorizontal: 20,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 3,
    flexDirection: 'row',
    width: '45%'
  },
  text: {
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '500',
    color: '#3F4A55'
  }
})
